/*eslint-disable*/
import "./styles.scss";

import FileSaver from "file-saver";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

import util from "./util";
import { fetchStudentsReport } from "../../../store/middleware";

function StudentReportModal({ setShowStudentReport }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { student } = useSelector((state) => state.b2bContractsReducer);

  const months = util.getMonths();
  const years = util.getYearsByYearInterval(5);

  const [dialog, setDialog] = useState({
    opened: false,
    title: "",
    message: "",
    onClose: () => console.log("You should implement the onClose function."),
  });
  const [generalState, setGeneralState] = useState({
    year: "",
    month: "",
    language: "",
    yearSelectClasses: ["input-lingo"],
    yearLabelClasses: "",
    monthSelectClasses: ["input-lingo"],
    monthLabelClasses: "",
    languageSelectClasses: ["input-lingo"],
    languageLabelClasses: "",
    error: "",
  });

  const loadInfos = () => {
    const dialogInitial = {
      opened: true,
      title: "Export student report",
      message: "",
      onClose: () => {
        handleBack();
      },
    };
    setDialog(dialogInitial);
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  const handleBack = () => {
    const d = { ...dialog, opened: false };

    setDialog(d);
    setShowStudentReport(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setGeneralState((state) => ({
      ...state,
      [name]: value,
      [name + "SelectClasses"]: "input-lingo",
      [name + "LabelClasses"]: "",
      [name + "language"]: "",
      error: "",
    }));
  };

  const generateReport = () => {
    const filters = Object.freeze({
      studentId: student.id,
      month: generalState.month,
      year: generalState.year,
      language: generalState.language,
    });

    if (validFilters()) {
      dispatch(fetchStudentsReport(filters))
        .then((response) => {
          if (response.headers["content-type"] === "application/zip") {
            var blob = new Blob([response.data]);
            FileSaver.saveAs(blob, "report.zip");
          } else {
            setGeneralState({
              ...generalState,
              error: "This student has no data in this period to generate a report!",
            });
          }
        })
        .catch(() => {
          setGeneralState({ ...generalState, error: "Error generating report" });
        });
    }
  };

  const validFilters = () => {
    let valid;
    if (generalState.month === "") {
      setGeneralState({ ...generalState, monthSelectClasses: "input-lingo input-red", monthLabelClasses: "label-red" });
      valid = false;
    } else {
      setGeneralState({ ...generalState, monthSelectClasses: "input-lingo", monthLabelClasses: "" });
      valid = true;
    }

    if (generalState.year === "") {
      setGeneralState({ ...generalState, yearSelectClasses: "input-lingo input-red", yearLabelClasses: "label-red" });
      valid = false;
    } else {
      setGeneralState({ ...generalState, yearSelectClasses: "input-lingo", yearLabelClasses: "" });
      valid = valid && true;
    }

    if (generalState.year === "") {
      setGeneralState({
        ...generalState,
        yearSelectClasses: "input-lingo input-red",
        yearLabelClasses: "label-red",
      });
      valid = false;
    } else {
      setGeneralState({ ...generalState, yearSelectClasses: "input-lingo", yearLabelClasses: "" });
      valid = valid && true;
    }

    if (generalState.language === "") {
      setGeneralState({
        ...generalState,
        languageSelectClasses: "input-lingo input-red",
        languageLabelClasses: "label-red",
      });
      valid = false;
    } else {
      setGeneralState({ ...generalState, languageSelectClasses: "input-lingo", languageLabelClasses: "" });
      valid = valid && true;
    }

    return valid;
  };

  return (
    <div>
      <Dialog open={dialog.opened} onClose={dialog.onClose} className="alert-dialog-slide report-modal">
        <DialogTitle className="alert-dialog-slide-title">{dialog.title}</DialogTitle>
        <DialogContent className="alert-dialog-slide-content">
          <p className="margin-top-20">
            <span className="font-weight-400">Student:</span>
            {student.name}
          </p>
          <span className="margin-top-30">Select report year and month:</span>
          <div className="lineInputs margin-top-20">
            <div className="item">
              <div>
                <label className={generalState.yearLabelClasses}>{t("Year")}</label>
                <span className="span">{t("REQUIRED")}</span>
              </div>
              <select onChange={handleChange} className={generalState.yearSelectClasses} name="year">
                <option value="">Year</option>
                {years.map((item) => {
                  return (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="item">
              <div>
                <label className={generalState.monthLabelClasses}>{t("Month")}</label>
                <span className="span">{t("REQUIRED")}</span>
              </div>
              <select onChange={handleChange} className={generalState.monthSelectClasses} name="month">
                <option value="">Month</option>
                {months.map((item) => {
                  return (
                    <option key={item.value} value={item.value}>
                      {item.description}
                    </option>
                  );
                })}
              </select>
            </div>

            <div>
              <div>
                <label className={generalState.languageLabelClasses}>{t("LANGUAGE")}</label>
                <span className="span">{t("REQUIRED")}</span>
              </div>
              <select
                onChange={handleChange}
                name="language"
                value={generalState.language}
                className={generalState.languageSelectClasses}
              >
                <option value="">{t("LANGUAGE")}</option>
                <option value="portuguese">{t("BTN_PORTUGUESE")}</option>
                <option value="english">{t("BTN_ENGLISH")}</option>
                <option value="spanish">{t("BTN_SPANISH")}</option>
              </select>
            </div>
          </div>
          <label className="label-red">{generalState.error}</label>
        </DialogContent>
        <DialogActions className="alert-dialog-slide-actions">
          <button className="new-button close" onClick={() => handleBack()}>
            {t("CANCEL")}
          </button>
          <button className="new-button" onClick={() => generateReport()} autoFocus>
            {t("GENERATE_REPORT")}
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default StudentReportModal;
